<template>
    <div>
        <div class="divider mx0 my3"></div>

        <span class="h3">
        ENDNUTZER-LIZENZVEREINBARUNG
        </span>
        <br><br>

        zwischen
        <br>
        Cobiax Deutschland GmbH
        <br>
        Am Stadtholz 56
        <br>
        33609 Bielefeld, Deutschland
        <br>
        gesetzlich vertreten durch die Geschäftsführung
        <br>
        Mehmet Kelmendi,
        <br>
        nachfolgend Cobiax Deutschland genannt 
        <br>
        <br>

        sowie
        <br>
        dem Nutzer der Softwareanwendung „CQL“ von Cobiax Deutschland
        <br>
        <br>

        <span class="semibold">
        WICHTIGER HINWEIS: LESEN SIE DIESE ENDNUTZER-LIZENZVEREINBARUNG SORGFÄLTIG DURCH UND STELLEN SIE SICHER, DASS SIE SIE VERSTANDEN HABEN, BEVOR SIE IHRE BESTIMMUNGEN AKZEPTIEREN. 
        <br>

        COBIAX DEUTSCHLAND IST NUR DANN BEREIT, DIE NACHFOLGEND DEFINIERTE SOFTWAREANWENDUNG AN SIE ALS NUTZER ODER UNTERNEHMER („NUTZER“) ZU LIZENZIEREN, WENN SIE ALLE BESTIMMUNGEN DIESER ENDNUTZER-LIZENZVEREINBARUNG UND DIE ZUGEHÖRIGEN GESCHÄFTSBEDINGUNGEN AKZEPTIEREN. 
        <br>
        INDEM SIE AUF DEN BUTTON „CQL NUTZUNGSBEDINGUNGEN AKZEPTIEREN“ KLICKEN, INDEM SIE DIE SOFTWAREANWENDUNG VERWENDEN ODER INDEM SIE AUF SONSTIGE WEISE IHRE ZUSTIMMUNG ZUM AUSDRUCK BRINGEN, AKZEPTIEREN SIE DIESE ENDNUTZER-LIZENZVEREINBARUNG, UND DURCH DIESE ENDNUTZER-LIZENZVEREINBARUNG WIRD EIN RECHTSGÜLTIGER UND ANWENDBARER VERTRAG ZWISCHEN COBIAX DEUTSCHLAND UND IHNEN SELBST, WENN SIE EIN NUTZER SIND, ODER ZWISCHEN COBIAX DEUTSCHLAND UND IHREM GESCHÄFTSUNTERNEHMEN, WENN SIE UNTERNEHMER SIND, GESCHLOSSEN. 
        <br>
        DER ABSCHLUSS DIESER ENDNUTZER-LIZENZVEREINBARUNG IST VORAUSSETZUNG FÜR DIE RECHTMÄSSIGE NUTZUNG DER SOFTWAREANWENDUNG „CQL“ (NACHFOLGEND „SOFTWARE“ GENANNT).
        <br>
        WENN SIE DIESEN BESTIMMUNGEN NICHT ZUSTIMMEN, KLICKEN SIE AUF „ABBRECHEN“.
        </span>
        <br>
        <br>
        <b class="h4">§ 1	Vertragsgegenstand/Anwendungsbereich</b>
        <span class="flex mt1">
        <span class="mr3">(1)</span>
        <span>Vertragsgegenstand ist die Softwareanwendung "CQL" in ihrer zum Zeitpunkt der Bereitstellung aktuellen Fassung.</span>
        </span>
        <span class="flex">
        <span class="mr3">(2)</span>
        <span>Die Software ist eine Software zur Unterstützung bei der Planung einer Decke mit Cobiax-Hohlkörperelementen.</span>
        </span>
        <span class="flex">
        <span class="mr3">(3)</span>
        <span>Der Software-Source-Code ist nicht Vertragsgegenstand.</span>
        </span>
        <span class="flex">
        <span class="mr3">(4)</span>
        <span>Diese Nutzungsbedingungen gelten nicht für Updates und Upgrades der Software; hier behält sich Cobiax Deutschland ausdrücklich das Recht vor, die Nutzung an zukünftige Bedingungen zu knüpfen, insbesondere an eine Registrierung des Nutzers.</span>
        </span>
        <br>
        <b class="h4">§2	Rechteeinräumung</b>
        <span class="flex mt1">
        <span class="mr3">(1)</span>
        <span>Die Software ist durch Urheberrechtsgesetze, -verträge und andere Gesetze geschützt. Cobiax Deutschland besitzt und behält alle Rechte, das Eigentum und alle Ansprüche an der Software, einschließlich aller Urheberrechte, Patente, Betriebs- und Geschäftsgeheimnisse, Marken und sonstiger geistiger Eigentumsrechte. Diese Endnutzer-Lizenzvereinbarung überträgt dem Nutzer kein Eigentum an der Software. Mit Ausnahme der in § 2 (2) bezeichneten Rechte erhält der Nutzer keinerlei Rechte an der Software.</span>
        </span>
        <span class="flex">
        <span class="mr3">(2)</span>
        <span>Cobiax Deutschland räumt dem Nutzer das unentgeltliche, nicht ausschließliche (einfache), nicht übertragbare, jederzeit widerrufliche Recht ein, die Software ausschließlich im Zusammenhang mit dem (potenziellen) Einsatz von Cobiax-Produkten zu nutzen.</span>
        </span>
        <span class="flex mb1">
        <span class="mr3">(3)</span>
        <span>Es ist dem Nutzer nicht erlaubt, und er darf auch keiner anderen Person gestatten:</span>
        </span>
        <span class="flex">
        <span class="ml3 pl2 mr3">a.</span>
        <span>Irgendeinen Teil der Software zu kopieren (außer zu Sicherungszwecken), unterzulizenzieren, zu vermieten, zu verleihen oder zu verleasen.</span>
        </span>
        <span class="flex">
        <span class="ml3 pl2 mr3">b.</span>
        <span>Die Software ganz oder teilweise zu verändern oder abgeleitete Werke zu schaffen, die ganz oder teilweise auf der Software basieren.</span>
        </span>
        <span class="flex">
        <span class="ml3 pl2 mr3">c.</span>
        <span>Eigentümerkennzeichnungen, Seriennummern, Beschriftungen oder Kopierschutzfunktionen von der Software zu entfernen, zu modifizieren oder unkenntlich zu machen. Gleiches gilt für eine Unterdrückung der Anzeige entsprechender Vermerke und Merkmale auf dem Bildschirm.</span>
        </span>
        <span class="flex mb1">
        <span class="ml3 pl2 mr3">d.</span>
        <span>Die Software zu ändern.</span>
        </span>
        <span class="flex">
        <span class="mr3">(4)</span>
        <span>Eine Vervielfältigung der Software ist dem Nutzer nur insoweit erlaubt, wie dies für die vertragsgemäße Nutzung der Software zwingend notwendig ist. Eine notwendige Vervielfältigung ist das Laden der Software in den Arbeitsspeicher. Weitere Vervielfältigungen, zu denen auch die Ausgabe des Programmcodes auf einem Drucker zählt, dürfen Sie nicht anfertigen.</span>
        </span>
        <span class="flex">
        <span class="mr3">(5)</span>
        <span>Die Software darf nicht vervielfältigt, weitergegeben oder dekompiliert (d.h. in den Quellcode rückübersetzt) werden, sofern dies nicht ausdrücklich durch diesen Vertrag oder durch ein Gesetz erlaubt ist. Falls der Nutzer die Software zurückentwickeln, dekompilieren oder disassemblieren (nachfolgend „Dekompilierung“ genannt) möchte, um eine Interoperabilität mit anderen Computerprogrammen zu erreichen, sofern dies gesetzlich erlaubt ist, hat der Nutzer Cobiax Deutschland vor der Dekompilierung der Software zu kontaktieren und die Bereitstellung der für das Erreichen einer solchen Interoperabilität erforderlichen Informationen anzufordern. Stellt Cobiax Deutschland diese Informationen bezüglich der Interoperabilität ohne schuldhaftes Zögern zur Verfügung, ist der Nutzer nicht zur Dekompilierung des Computerprogramms berechtigt. </span>
        </span>
        <span class="flex">
        <span class="mr3">(6)</span>
        <span>Cobiax Deutschland weist ausdrücklich darauf hin, dass jede Verletzung der vorstehenden Lizenzbedingungen oder der sonstigen Vertragsbestimmungen zivil- und, soweit erforderlich, strafrechtlich verfolgt wird. </span>
        </span>


        <br>

        <b class="h4">§ 3	Mängelansprüche, Haftung</b>
        <span class="flex mt1">
        <span class="mr3">(1)</span>
        <span>Cobiax Deutschland haftet ausschließlich für Vorsatz und grobe Fahrlässigkeit. Jede weitergehende Haftung ist ausgeschlossen.</span>
        </span>
        <span class="flex">
        <span class="mr3">(2)</span>
        <span>Cobiax Deutschland ist nur dann zum Schadensersatz verpflichtet, wenn Cobiax Deutschland einen Mangel im Recht oder einen Fehler der Software arglistig verschweigt. Jede weitergehende Mängelhaftung ist ausgeschlossen.</span>
        </span>
        <span class="flex">
        <span class="mr3">(3)</span>
        <span>Cobiax Deutschland haftet unter keinen Umständen für mangelnden wirtschaftlichen Erfolg, entgangenen Gewinn und / oder mittelbare Schäden. Der Nutzer ist für eine regelmäßige Sicherung seiner Daten verantwortlich. Bei einem verschuldeten Datenverlust haftet Cobiax Deutschland nach Maßgabe der vorstehenden Bestimmung deshalb ausschließlich für die Kosten der Vervielfältigung der Daten, die zur erstellenden Sicherheitskopien und für Kosten der Wiederherstellung der Daten, die auch bei einer ordnungsgemäß erfolgten Sicherung der Daten verloren gegangen wären.</span>
        </span>
        <span class="flex">
        <span class="mr3">(4)</span>
        <span>Etwaige Ersatzansprüche von Cobiax Deutschland verjähren innerhalb von zwei Jahren ab erster Registrierung.</span>
        </span>
        <span class="flex">
        <span class="mr3">(5)</span>
        <span>Es wird darauf hingewiesen, dass es nicht möglich ist, Computersoftware so zu erstellen, dass sie in allen Kombinationen und Anwendungen fehlerfrei arbeitet. Es wird daher keinerlei Haftung für die Richtigkeit und Vollständigkeit durch Cobiax Deutschland übernommen. Der Anwender und Nutzer bleibt verantwortlich die Eingabe- und Ausgabewerte anhand aktueller Unterlagen (Normen, Zulassungen, Produktbeschreibungen etc.) auf Fehlerfreiheit zu prüfen.</span>
        </span>
        <span class="flex">
        <span class="mr3">(6)</span>
        <span>Jegliche Art und Haftung und / oder Gewährleistung besteht dann nicht, wenn der Einsatz der Software nicht ausschließlich auf den potenziellen Gebrauch von Cobiax-Produkten verwandt wird.</span>
        </span>
        <br>

        <b class="h4">§ 4	Geheimhaltung</b>
        <br>
        <span class="flex mt1 mb1">
        <span class="">Der Nutzer ist verpflichtet, sämtliche von Cobiax Deutschland gelieferten Programme, Codes und Dokumentationen sowie Konzeptionen als Betriebs- und Geschäftsgeheimnisse von Cobiax Deutschland zu behandeln und strikt geheim zu halten.
        </span>
        </span>
        <br>
        <b class="h4">§ 5	Allgemeines</b>
        <span class="flex mt1">
        <span class="mr3">(1)</span>
        <span>Sämtliche Vereinbarungen, die eine Änderung, Ergänzung oder Konkretisierung dieser Vertragsbedingungen beinhalten, sowie besondere Zusicherungen, Garantien und Abmachungen sind schriftlich niederzulegen. Dies gilt auch für die Abänderung des Schriftformerfordernisses. Werden sie von Dritten oder Hilfspersonen von Cobiax Deutschland erklärt, sind sie nur dann verbindlich, wenn Cobiax Deutschland hierfür seine schriftliche Zustimmung erteilt.</span>
        </span>
        <span class="flex">
        <span class="mr3">(2)</span>
        <span>Nutzer sind nur dann zur Aufrechnung berechtigt, soweit eine Ihnen zustehende Gegenforderung rechtskräftig festgestellt oder von Cobiax Deutschland anerkannt oder unbestritten ist. Ein Zurückbehaltungsrecht können Nutzer nur dann ausüben, soweit es Ansprüche aus diesem Vertrag betrifft.</span>
        </span>
        <span class="flex">
        <span class="mr3">(3)</span>
        <span>Es gilt ausschließlich deutsches Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand für alle Rechtsstreitigkeiten aus diesem Vertrag ist - soweit gesetzlich zulässig - Bielefeld.</span>
        </span>
        <span class="flex">
        <span class="mr3">(4)</span>
        <span>Mit Akzeptanz dieser Nutzungsbedingungen erklärt sich der Nutzer ebenfalls damit einverstanden, regelmäßig über einen elektronischen Newsletter über Neuerungen an den Produkten, der Software oder andere betriebliche Belange und erwähnenswerte Fakten aus der Baubranche von Cobiax Deutschland informiert zu werden.</span>
        </span> 
        <span class="flex">
        <span class="mr3">(5)</span>
        <span>Sollte eine Regelung dieses Vertrages unwirksam sein oder werden, so wird dadurch die Gültigkeit dieses Vertrages im Übrigen nicht berührt. Die Vertragspartner sind im Rahmen des Zumutbaren nach Treu und Glauben verpflichtet, die unwirksame Bestimmung durch eine ihr wirtschaftlich nahekommende, zulässige Regelung zu ersetzen, sofern dadurch keine wesentliche Änderung des Vertragsinhalts herbeigeführt wird.</span>
        </span> 
    </div>               
</template>

<script>

export default {
  name: 'contract-text-de',
}
</script>

<style scoped>
</style>